import React from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import Button from 'shared/components/button/Button';
import {
  handleVerifyEmail
} from '../../ducks/actionsAuthActions';
import InvalidAction from '../InvalidAction/InvalidAction';

class VerifyEmail extends React.Component {
  componentDidMount() {
    this.props.handleVerifyEmail(this.props.code);
  }

  setGetStarted = () => {
    let { continueUrl } = this.props;
    if (continueUrl.includes("client_login")) {
      return window.location.assign(process.env.REACT_APP_DYNAMIC_LINK_DOMAIN + 'client_login');
    }
    return window.location.assign(process.env.REACT_APP_DYNAMIC_LINK_DOMAIN + 'trainer_login');
  }

  render() {
    let { isEmailVerified, emailVerificationError, loading } = this.props;

    if (loading) {
      return (<Loader/>);
    }

    if (!isEmailVerified) {
      return (
        <InvalidAction
          title="Something Went Wrong!"
          description={emailVerificationError}
        />
      );
    }

    return (
      <div className="activation-page">
        <div className="activation-content">
          <h3 className="welcome-msg">
            Welcome, Your email has successfully verified! <br /> Download TrackMyTraining by HYBRID to begin
          </h3>
          <div className="form-action">
            <Button
              id=""
              type="submit"
              btnBlock="block"
              color="primary"
              label="Get Started"
              onClick={() => this.setGetStarted()}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isEmailVerified: state.actionsReducer.isEmailVerified,
    emailVerificationError: state.actionsReducer.emailVerificationError,
    loading: state.actionsReducer.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleVerifyEmail: code => dispatch(handleVerifyEmail(code))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyEmail);
